import { FC } from 'react';
import { Box, Button, Typography, keyframes } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PersonIcon from '@mui/icons-material/Person';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/rootReducerType';
import { fadeStyle } from '../constants';

const checkmarkPop = keyframes`
  0% { transform: scale(0); opacity: 0; }
  50% { transform: scale(1.15); }
  100% { transform: scale(1); opacity: 1; }
`;

interface TransferSuccessViewProps {
  newHohName: string;
  demotedMemberName: string;
  onComplete: () => void;
}

const TransferSuccessView: FC<TransferSuccessViewProps> = ({
  newHohName,
  demotedMemberName,
  onComplete,
}) => {
  const householdsTransferred = useSelector(
    (state: RootState) => state.newRenterInterface.householdsTransferred
  );
  const unconfirmedHouseholds = useSelector(
    (state: RootState) => state.newRenterInterface.unconfirmedHouseholds
  );

  const hasMore =
    householdsTransferred.length > 1 ||
    unconfirmedHouseholds.length - householdsTransferred.length > 0;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 280,
        gap: 2,
        ...fadeStyle,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}
      >
        <HomeIcon sx={{ fontSize: 40, color: 'primary.main' }} />
        <ArrowForwardIcon sx={{ fontSize: 32, color: 'info.main' }} />
        <PersonIcon sx={{ fontSize: 40, color: 'primary.main' }} />
      </Box>
      <Typography variant="h6" fontWeight={600} textAlign="center">
        Household transferred from{' '}
        <strong style={{ textTransform: 'capitalize' }}>
          {demotedMemberName}
        </strong>{' '}
        to <strong style={{ textTransform: 'capitalize' }}>{newHohName}</strong>{' '}
        successfully.
      </Typography>
      <CheckCircleIcon
        sx={{
          fontSize: 64,
          color: 'success.main',
          animation: `${checkmarkPop} 0.5s ease-out 0.3s forwards`,
          opacity: 0,
        }}
      />
      <Button
        variant="contained"
        size="large"
        onClick={onComplete}
        sx={{ mt: 1 }}
      >
        {hasMore ? 'Next' : 'Continue'}
      </Button>
    </Box>
  );
};

export default TransferSuccessView;
